module.exports = __webpack_public_path__ + "img/palm-oil.bf063db0.svg";